import React from 'react';

const User = (props) => {
    return (
        props.user &&
        <div className="button-wrapper">
            <button data-cy="fele-user" className={`user ${props.user.isActive === true ? "active" : ""} ${props.isSelected ? "is-visible" : ""}`}>
                <div className="col">
                    <div className="indicator" style={{ backgroundColor: (props.user.isActive === true ? 'limegreen' : 'lightgray') }}></div>
                </div>
                <div className="col-wrapper">
                    <div className="col">
                        <div className="name">{props.user.firstName} {props.user.lastName}</div>
                        <div className="role">{props.user.personaDisplayName}</div>
                    </div>
                    <div className="col">
                        <div className="number"></div>
                        <div className="email">{props.user.email}</div>
                    </div>
                </div>
            </button>
        </div>
    )
}
export default User;